var path = 'scripts/views/components/pagination-display.html';
var html = "<span class=\"pagination-display\">\n    <span id=\"pagination-display-range\">{{ \"pagination.Showing\" | translate }} {{ $ctrl.pageStart() }}-{{ $ctrl.pageEnd() }}</span>\n    <span id=\"pagination-display-total\">{{ \"pagination.Of\" | translate }} {{ $ctrl.totalCount() }}</span>\n</span>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/views/components/pagination-display.html
// module id = 327
// module chunks = 0